import { call, fork, put } from 'redux-saga/effects';
import { signalingContentCleared } from 'features/application/actions';
import { publicChatCleared } from 'features/chat/chatSlice';
import { sharedFilesCleared } from 'features/content-library/contentLibrarySlice';
import { clearQASaga } from 'features/qa/sagas/clearQASaga';
import { clearPollsSaga } from 'features/polls/sagas/clearPollsSaga';
import { clearQuizzesSaga } from 'features/quizzes/sagas/clearQuizzesSaga';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';

export function* onContentClearedSaga(action: ReturnType<typeof signalingContentCleared>) {
  const { payload } = action;

  if (payload.publicChat) {
    yield put(publicChatCleared());
  }

  if (payload.sharedFiles) {
    yield put(sharedFilesCleared());
  }

  if (payload.qa) {
    yield fork(clearQASaga);
  }

  if (payload.pollResults) {
    yield fork(clearPollsSaga);
  }

  if (payload.quizResults) {
    yield fork(clearQuizzesSaga);
  }

  yield call(notification, i18n.t('notifications:content_cleared'));
}
